import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  repo: z.string().min(1),
  branch: z.string().optional(),
  per_page: z.coerce.number().optional().default(50),
});

export type InputType = z.infer<typeof schema>;

export type CommitInfo = {
  sha: string;
  shortSha: string;
  message: string;
  authorName: string;
  authorAvatar: string;
  date: string;
  parents: string[];
};

export type OutputType = {
  commits: CommitInfo[];
};

export const getGithubCommits = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ repo: input.repo });
  if (input.branch) params.set('branch', input.branch);
  if (input.per_page) params.set('per_page', String(input.per_page));

  const result = await fetch(`/_api/github/commits?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const text = await result.text();
    try {
      const errorObject = superjson.parse<{ error: string }>(text);
      throw new Error(errorObject.error);
    } catch {
      throw new Error(text || 'Failed to fetch commits');
    }
  }
  return superjson.parse<OutputType>(await result.text());
};
